import type { VFC } from 'react';

import { icons } from '../../generic';
import TooltipIcon from '../../generic/TooltipIcon';

type Props = {
  title: string;
};

/**
 * IgnoreReasonTitle should be used when the label or title of FOSSA ignore reasons (currently vulnerabilty issues)
 * needs a tooltip to accompany it explaining the reasons provided
 */
const IgnoreReasonTitle: VFC<Props> = ({ title }) =>
  <>
    <span className="margin-right-xs">{title}</span>
    <TooltipIcon
      id="tooltip-ignore-reason-title"
      icon={icons.questionCircle}
      tooltip={
        `Ignore reasons support both CISA VEX (Vulnerability Exploitability Exchange) "NOT AFFECTED" status justifications and FOSSA provided justifications.`
      }
    />
  </>;

export default IgnoreReasonTitle;
